export default __webpack_public_path__ + "static/media/spinner.ccbbf8f1.gif";